var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import GlobalVue from "../../globalVue";
import OrderService from '../../api/OrderService';
import CommonService from '../../api/CommonService';
import GoodTable from "./GoodTable.vue";
import Ship from "./Ship.vue";
import { EPurOrderStatus, EShipStatus } from "../../enum/EStatus";
import { EPurOrderErrorCode } from "../../enum/EPurchaseOrderCode";
import { EBillType } from "../../enum/EBillType";
import { toDetail } from "../../helper/util";
import ELogisticsType from "../../enum/ELogisticsType";
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { Loading } from 'element-ui';
import { mapGetters, mapActions } from "vuex";
import _ from 'lodash';
import SendGoodsDialog from './component/SendGoodsDialog.vue';
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import Add from './Add';
import addRefund from '../shopAfterSales/Add.vue';
import TableHintInfo from './TableHintInfo.vue';
import { handleException } from "../../common/ErrorCodeHandle";
var PurOrderDetail = (function (_super) {
    __extends(PurOrderDetail, _super);
    function PurOrderDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rowId = null;
        _this.tableHeight = 300;
        _this.billData = {};
        _this.goodData = [];
        _this.ediBusinessStatus = [];
        _this.shopGoodData = [];
        _this.defaultType = "byGood";
        _this.purOrderStatus = EPurOrderStatus;
        _this.fromPage = "detail";
        _this.eLogisticsType = ELogisticsType;
        _this.showDelivery = false;
        _this.err_codes = [42, 43, 44, 45];
        _this.isRefundShow = false;
        _this.showDisCardBtn = false;
        _this.supplierGoodsTypeList = [];
        _this.formData = {
            goods_type_id: undefined,
            keyword: '',
        };
        return _this;
    }
    PurOrderDetail.prototype.created = function () {
        this.service = OrderService.getInstance();
        this.commonService = CommonService.getInstance();
        this.getEdiBusinessList();
        this.getGoodList();
        this.getGoodsTypeList();
    };
    PurOrderDetail.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 300;
        }, 300);
        this.initStoreAuth();
    };
    PurOrderDetail.prototype.initStoreAuth = function () {
        var _this = this;
        this.getPageAuth('310002').then(function (pageAuth) {
            _this.isRefundShow = pageAuth && pageAuth.Auth && pageAuth.Auth.Add;
        });
    };
    PurOrderDetail.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    PurOrderDetail.prototype.search = function () {
        this.getGoodList();
    };
    PurOrderDetail.prototype.getGoodsTypeList = function () {
        var _this = this;
        this.commonService.getSupplierGoodsTypeList().then(function (res) {
            if (res.data.success) {
                _this.supplierGoodsTypeList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    PurOrderDetail.prototype.getGoodList = function () {
        var _this = this;
        var params = {
            order_id: this.rowId,
            goods_type_id: this.formData.goods_type_id,
            keyword: this.formData.keyword,
        };
        console.log(1111111, params, Object.assign(params, this.formData));
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getGoodList(params).then(function (res) {
            var data = res.data.data;
            _this.billData = data;
            _this.filterEdiStatus();
            _this.billData.sorting_order_codes_str = '';
            _this.billData.sorting_order_codes && _this.billData.sorting_order_codes.length && _this.billData.sorting_order_codes.forEach(function (item) {
                if (!_this.billData.sorting_order_codes_str) {
                    _this.billData.sorting_order_codes_str = item.order_code;
                }
                else {
                    _this.billData.sorting_order_codes_str = _this.billData.sorting_order_codes_str + "," + item.order_code;
                }
            });
            _this.goodData = data.items;
            _this.goodData.forEach(function (item, index) {
                if (item.order_goods_replace && item.order_goods_replace.length !== 0) {
                    item.children = [item.order_goods_replace];
                }
                item.isIndex = true;
                item.parentIndex = index + 1;
            });
            _this.shopGoodData = data.shop_items;
            _this.shopGoodData.map(function (shop) {
                shop.items.map(function (item, index) {
                    if (item.order_goods_replace && item.order_goods_replace.length !== 0) {
                        item.children = [item.order_goods_replace];
                    }
                    item.isIndex = true;
                    item.parentIndex = index + 1;
                });
            });
            _this.showDelivery = data.order_sup_status == EPurOrderStatus.Shipped ||
                data.order_sup_status == EPurOrderStatus.Complete || data.delivery_status == EShipStatus.PartShip;
            _this.isRefundShow = _this.isRefundShow && data.order_sup_status == EPurOrderStatus.Complete;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderDetail.prototype.getEdiBusinessList = function () {
        var _this = this;
        this.service.getEdiBusinessList().then(function (res) {
            var data = res.data.data;
            _this.ediBusinessStatus = data;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderDetail.prototype.filterEdiStatus = function () {
        var _this = this;
        this.billData.edi_business_status = false;
        _.forEach(this.ediBusinessStatus, function (business) {
            if (_this.billData.business_id == business.business_id)
                _this.billData.edi_business_status = business.edi_business_status;
        });
    };
    PurOrderDetail.prototype.audit = function (params) {
        var _this = this;
        var msg = '审核后，订单不可更改，且默认为待发货状态，请确认是否继续？';
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            var orderIds = _this.rowId;
            var paramsData = {
                ids: params && params.orderIds || orderIds,
                code: params && params.code || '',
                type: params && params.type || ''
            };
            _this.auditAjax(paramsData);
        }).catch(function () { });
    };
    PurOrderDetail.prototype.auditAjax = function (paramsData) {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.review(paramsData).then(function (res) {
            var errCode = res.data.code;
            if (_this.err_codes.indexOf(res.data.code) > -1) {
                var instance = _this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350
                }).instance;
                instance.$on("artMsglist:ok", function (data) {
                    _this.auditAjax({
                        ids: paramsData.ids,
                        code: res.data.code,
                        type: data || ''
                    });
                });
            }
            else {
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getGoodList();
                }
                else {
                    loadingInstance.close();
                    _this.$message.success(res.data.msg || "审核成功");
                    _this.getEdiBusinessList();
                    _this.getGoodList();
                }
            }
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderDetail.prototype.discard = function (status) {
        var _this = this;
        var msg = "";
        var params = {};
        if (status == 1) {
            msg = '确认后会废弃订货单且不可恢复，确定废弃吗？';
            params = {
                ids: this.rowId,
                type: 2
            };
        }
        else {
            msg = '确定要废弃选中的订单吗？';
            params = {
                ids: this.rowId,
            };
        }
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.cancel(params).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getGoodList();
                }
                else {
                    _this.$message.success(res.data.msg || "废弃成功");
                    _this.getEdiBusinessList();
                    _this.getGoodList();
                    if (_this.opener) {
                        _this.opener.search();
                    }
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }).catch(function () { });
    };
    PurOrderDetail.prototype.addRefundOrder = function () {
        console.log('添加');
        GlobalVue.$emit("addTab", {
            component: addRefund,
            title: '新增售后工单',
            showExist: true,
            name: 'add_refund_order',
            cprops: {
                rowId: '0',
                opener: this,
                keyword: this.billData.order_code,
            }
        });
    };
    PurOrderDetail.prototype.sendGoods = function () {
        var _this = this;
        if (this.openedCodeData.isOnlyOpenERP) {
            var instance = this.$dialog(SendGoodsDialog, {
                data: {
                    order_id: this.billData.order_id
                }
            }, {
                title: "发货",
                width: 400,
                height: 230
            }).instance;
            instance.$on("addClient:ok", function (data) {
                var row = Object.assign(_this.billData, data);
                GlobalVue.$emit("addTab", {
                    component: Ship,
                    title: '发货',
                    opener: _this,
                    showExist: true,
                    name: 'send' + row.order_id,
                    cprops: {
                        orderRowId: row.order_id,
                        organRowId: row.organ_id,
                        depotRowId: row.depot_id,
                        isEdit: true
                    }
                });
            });
        }
        else {
            GlobalVue.$emit("addTab", {
                component: Ship,
                title: '发货',
                opener: this,
                showExist: true,
                name: 'send' + this.billData.order_id,
                cprops: {
                    orderRowId: this.billData.order_id,
                    organRowId: this.billData.organ_id,
                    depotRowId: this.billData.depot_id,
                    isEdit: true
                }
            });
        }
    };
    PurOrderDetail.prototype.confirm = function () {
        var _this = this;
        this.$confirm("是否要确认?", "提示", {}).then(function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.confirmMul({ order_id: _this.billData.order_id }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 0) {
                    _this.$message.success(res.data.msg || "确认成功");
                    GlobalVue.$emit('closeTab', _this);
                    if (_this.opener) {
                        _this.opener.search();
                    }
                    ;
                    return;
                }
                else if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getGoodList();
                    return;
                }
                if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                    handleException(_this, res.data, _this.billData);
                    return;
                }
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        });
    };
    PurOrderDetail.prototype.toDeliverDetail = function (item) {
        if (this.billData.logistics_type == 4 || this.billData.logistics_type == 5) {
            toDetail(EBillType.EntrustedDeliver, item.delivery_order_id);
        }
        else {
            toDetail(EBillType.Deliver, item.delivery_order_id);
        }
    };
    PurOrderDetail.prototype.toPurInDetail = function (item) {
        toDetail(EBillType.PurIn, item.warehouse_receipt_id);
    };
    PurOrderDetail.prototype.save = function () {
    };
    PurOrderDetail.prototype.editOrder = function () {
        GlobalVue.$emit("addTab", {
            component: Add,
            title: '编辑订货单',
            opener: this,
            showExist: true,
            name: 'purchaseorder_edit' + this.billData.order_id,
            cprops: {
                orderid: this.billData.order_id
            }
        });
    };
    PurOrderDetail.prototype.copyData = function () {
        var order_id = this.rowId;
        GlobalVue.$emit("addTab", {
            component: Add,
            title: '复制订货单',
            opener: this,
            showExist: true,
            name: 'purchaseorder_copy' + order_id,
            cprops: {
                targetOrderId: order_id,
                pageUse: 'copy'
            }
        });
    };
    PurOrderDetail = __decorate([
        auth(nameDict["订货单"]),
        Component({
            filters: {
                total: function (row) {
                    var total = (row.price * row.send_amount).toFixed(2);
                    return isNaN(total) ? 0 : total;
                }
            },
            components: {
                GoodTable: GoodTable,
                TableHintInfo: TableHintInfo
            },
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList',
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus'
            }), { showDisCardBtn: function () {
                    if (this.billData.order_sup_status == this.purOrderStatus.Bconfirm) {
                        if (this.openedCodeData.isOrderService && this.billData.from_system === 4) {
                            return true;
                        }
                        else if (this.openedCodeData.isOpenInterMall && this.billData.from_system === 5) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else if (this.billData.order_sup_status == this.purOrderStatus.Bship) {
                        if (this.openedCodeData.isOrderService && this.billData.from_system == 4 && !this.openedCodeData.isOpenSorting) {
                            return true;
                        }
                        else if (this.openedCodeData.isOpenInterMall && this.billData.from_system == 5 && !this.ediStatus) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                } }),
            methods: __assign({}, mapActions({
                'getPageAuth': 'getAuth'
            }))
        })
    ], PurOrderDetail);
    return PurOrderDetail;
}(Vue));
export default PurOrderDetail;
